import React from "react";
import { CheckCircleFilled } from "@ant-design/icons";
import moment from "moment";
import "moment/locale/es";
import { ModalItem, ButtonItem } from "../../../../Components/Items";
import { SOPORTE_TEMA } from "./fasesSoporte";
import AccionesSubido from "./AccionesSubido";

moment.locale("es");

/**
 * Se muestra al entrar al panel cuando hay reportes del
 * usuario que pasaron a la fase "subido" y todavía no se le anuncian. Al cerrarlo
 * se marcan como vistos en el backend, así que no vuelve a aparecer.
 *
 */
const ModalSubidosSoporte = ({ visible, tickets = [], onCerrar, onVerReportes, onResponder, respondiendoId }) => {
  const varios = tickets.length > 1;

  return (
    <ModalItem
      visible={visible}
      title={varios ? `${tickets.length} de tus reportes ya están aplicados` : "Tu reporte ya está aplicado"}
      onCancel={onCerrar}
      footer={null}
      destroyOnClose
      width={620}
      spinning={false}
    >
      <div style={{ fontSize: 13, color: SOPORTE_TEMA.textPrimary, marginBottom: 14 }}>
        {varios
          ? "Estos tickets ya fueron resueltos y los cambios ya están en el sistema:"
          : "Este ticket ya fue resuelto y el cambio ya está en el sistema:"}
      </div>

      <div style={{ maxHeight: 340, overflowY: "auto" }}>
        {tickets.map((ticket) => (
          <div
            key={ticket._id}
            style={{
              display: "flex",
              gap: 10,
              padding: "10px 12px",
              marginBottom: 8,
              border: `1px solid ${SOPORTE_TEMA.border}`,
              borderLeft: `3px solid #52c41a`,
              borderRadius: 6,
              backgroundColor: SOPORTE_TEMA.bg,
            }}
          >
            <CheckCircleFilled style={{ color: "#52c41a", fontSize: 16, marginTop: 2, flexShrink: 0 }} />
            <div style={{ minWidth: 0 }}>
              <div style={{ fontSize: 13, fontWeight: 600, color: SOPORTE_TEMA.textPrimary }}>
                {ticket.folio} — {ticket.titulo}
              </div>
              {ticket.descripcion && (
                <div
                  style={{
                    fontSize: 12,
                    color: SOPORTE_TEMA.textSecondary,
                    marginTop: 2,
                    whiteSpace: "pre-wrap",
                    wordBreak: "break-word",
                  }}
                >
                  {ticket.descripcion}
                </div>
              )}
              {ticket.fechaSubido && (
                <div style={{ fontSize: 11, color: SOPORTE_TEMA.textSecondary, marginTop: 4 }}>
                  Aplicado el {moment(ticket.fechaSubido).format("LL")}
                </div>
              )}
              {onResponder && (
                <div style={{ marginTop: 10 }}>
                  <AccionesSubido
                    ticket={ticket}
                    guardando={respondiendoId === ticket._id}
                    onResponder={(respuesta) => onResponder(ticket, respuesta)}
                    compacto
                  />
                </div>
              )}
            </div>
          </div>
        ))}
      </div>

      <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 16 }}>
        {onVerReportes && (
          <ButtonItem azul onClick={onVerReportes}>
            Ver mis reportes
          </ButtonItem>
        )}
        <ButtonItem blanco onClick={onCerrar}>
          Después
        </ButtonItem>
      </div>
    </ModalItem>
  );
};

export default ModalSubidosSoporte;
